import { render, staticRenderFns } from "./SettingsStageFullDoubleElimination.vue?vue&type=template&id=403fd70a&"
import script from "./SettingsStageFullDoubleElimination.vue?vue&type=script&lang=js&"
export * from "./SettingsStageFullDoubleElimination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports